export const pipe =
  <T>(...functions: Function[]) =>
  (args: T) =>
    functions.reduce((updatedArgs, fn) => fn(updatedArgs), args);
